// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__W-5RP","logo":"styles_logo__2s-8E","blingbling":"styles_blingbling__x9OiO"};